import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    apiUrl: string;
    conversationApiUrl:string;
    externalApi: string;

    constructor() {
        this.apiUrl = this.setApiUrl(environment.apiUrl);
        this.conversationApiUrl = this.setApiUrl(environment.conversationApi);
        this.externalApi = environment.externalApi;
    }

    private setApiUrl(url) {
        // Azure App Service URLs with the -configuration.ebo.ai suffix don't resolve via DNS.
        // Strip the suffix so requests go directly to the Azure hostname.
        url = url.replace(/^(https?:\/\/[\w-]+\.azurewebsites\.net)-configuration\.ebo\.ai/, '$1');
        if (url.substr(-1) != '/') { url += '/' };
        return url;
    }
}
